import type { FC } from "react";
import type { JSX } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { IconButton } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import {
    ButtonStyle,
    ButtonWrapper,
    CloseIcon,
    ButtonText,
    EducationContainer,
    EducationContainerBig,
    EducationHat,
    Text,
    Image,
    Info,
    Title,
    Description,
    VideoButton,
    GuideButton,
    VideoTimeText,
    ButtonTitle,
    IconPlay,
    ButtonTextWrapper,
    ButtonTextIcon,
} from "./SubNavEducationBarProminentStyles";
import { colorsPalettes } from "@similarweb/styles";
import { allTrackers } from "app/services/track/track";

interface ISubNavEducationBar {
    onCloseEducationBar: () => void;
    onWatchVideoClick?: () => void;
    onGetStartedClick?: () => void;
    videoButtonText?: string;
    guideText?: string;
    guideButtonText?: string;
    isBig: boolean;
}

export const SubNavEducationBarProminent: FC<ISubNavEducationBar> = ({
    onCloseEducationBar,
    onWatchVideoClick = null,
    onGetStartedClick = null,
    videoButtonText = "",
    guideText = "",
    guideButtonText = "",
    isBig,
}): JSX.Element => {
    const hoverEvent = () => {
        allTrackers.dispatchTrackEvent("Topbar", "show", "EducationBanner/Hover over banner");
    };

    return (
        <>
            {isBig ? (
                <EducationContainerBig
                    onMouseEnter={hoverEvent}
                    id="educationBarProminent"
                >
                    <Info>
                        <EducationHat
                            src={AssetsService.assetUrl("/images/education-banner-hat-prominent.svg")}
                            alt="education-hat"
                        />
                        <div>
                            <Title>{i18nFilter()("growth.education.bar_prominent.title")}</Title>
                            <Description>{i18nFilter()("growth.education.bar_prominent.description")}</Description>
                        </div>
                    </Info>
                    {onWatchVideoClick ? (
                        <ButtonWrapper onClick={onWatchVideoClick}>
                            <VideoButton>
                                <Image
                                    src={AssetsService.assetUrl("/images/education-banner-new-video.png")}
                                    alt="education-hat"
                                />
                                <IconPlay
                                    iconName={"play-borderless"}
                                    iconSize={"md"}
                                    iconColor={colorsPalettes.carbon[0]}
                                ></IconPlay>
                                <VideoTimeText>
                                    {i18nFilter()("growth.education.bar_prominent.time_video")}
                                </VideoTimeText>
                            </VideoButton>
                        </ButtonWrapper>
                    ) : null}
                    {onGetStartedClick ? (
                        <ButtonWrapper>
                            <GuideButton onClick={onGetStartedClick}>
                                <ButtonTitle>{guideText}</ButtonTitle>
                                <ButtonTextWrapper>
                                    <ButtonTextIcon
                                        iconName={"Help-icon"}
                                        iconSize={"xs"}
                                        iconColor={colorsPalettes.blue[400]}
                                    ></ButtonTextIcon>
                                    <ButtonText>{guideButtonText}</ButtonText>
                                </ButtonTextWrapper>
                            </GuideButton>
                        </ButtonWrapper>
                    ) : null}
                    <PlainTooltip
                        placement="top"
                        tooltipContent={i18nFilter()("growth.education.bar_prominent.button.close.tooltip")}
                    >
                        <CloseIcon>
                            <IconButton
                                iconName="clear"
                                iconSize="xs"
                                type="flat"
                                onClick={onCloseEducationBar}
                            />
                        </CloseIcon>
                    </PlainTooltip>
                </EducationContainerBig>
            ) : (
                <EducationContainer>
                    <EducationHat
                        src={AssetsService.assetUrl("/images/education-banner-hat-prominent.svg")}
                        alt="education-hat"
                    />
                    <Text>{i18nFilter()("growth.education.bar_prominent.text")}</Text>

                    {onWatchVideoClick ? (
                        <ButtonStyle
                            type="flat"
                            onClick={onWatchVideoClick}
                            iconName={"Video-icon"}
                        >
                            {videoButtonText}
                        </ButtonStyle>
                    ) : null}
                    {onGetStartedClick ? (
                        <ButtonStyle
                            type="flat"
                            onClick={onGetStartedClick}
                            iconName={"Help-icon"}
                        >
                            {guideButtonText}
                        </ButtonStyle>
                    ) : null}

                    <PlainTooltip
                        placement="top"
                        tooltipContent={i18nFilter()("growth.education.bar_prominent.button.close.tooltip")}
                    >
                        <CloseIcon>
                            <IconButton
                                iconName="clear"
                                iconSize="xs"
                                type="flat"
                                onClick={onCloseEducationBar}
                            />
                        </CloseIcon>
                    </PlainTooltip>
                </EducationContainer>
            )}
        </>
    );
};
